module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rightContent"
  }, [_c('trainMenu', {
    ref: "trainmenu",
    attrs: {
      "trainCategories": _vm.trainCategories,
      "isModal": _vm.isModal
    },
    on: {
      "category-path-updated": _vm.onTrainCategoryChoose
    }
  }), _vm._v(" "), _c(_vm.currentView, {
    ref: "traincontent",
    tag: "component",
    attrs: {
      "trainCategories": _vm.trainCategories,
      "trainList": _vm.currentTrainCategory ? _vm.sortGame(_vm.currentTrainCategory.games) : []
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d64405a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/evaluation.vue
// module id = 973
// module chunks = 2